<template>
  <div>
    <gg-card>
      <gg-card-header>
        {{ title }}
      </gg-card-header>
      <gg-card-text>
        <v-form class="my-2">
          <v-row>
            <slot name="before-password" />
            <v-col cols="12" md="4">
              <compact-password
                outlined
                cpanel-app="passwd"
                v-model="password"
                show-strength
                with-generator
                charset="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMOPRSTUVWXYZ0123456789_"
                autocomplete="new-password"
                label="New Password"
                v-validate="'required|min:8'"
                data-vv-name="password"
                data-vv-as="Password"
                :error-messages="errors.collect('password')"
              />
            </v-col>
          </v-row>
          <gg-btn
            class="mt-2 ml-0"
            @click="changePassword"
            :loading="loading"
          >
            Change Password
          </gg-btn>
        </v-form>
      </gg-card-text>
    </gg-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CompactPassword from '@/components/Common/password/CompactPassword'

export default {
  name: 'HostingPassword',
  components: {
    CompactPassword,
  },
  props: {
    title: {
      type: String,
      default: 'Change Password',
    }
  },
  data () {
    return {
      password: '',
      loading: false,
    }
  },
  methods: {
    ...mapActions(['setHostingPassword', 'reportError', 'reportSuccess']),
    reset () {
      this.password = ''
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    async changePassword () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.loading = true
      const data = {
        pass: this.password,
        username: this.$route.query.user,
      }
      try {
        const message = await this.setHostingPassword(data)
        this.reportSuccess(message)
      } catch (e) {
        this.reportError(e)
      }
      this.loading = false
      this.reset()
    },
  }
}
</script>
